import { TBeginnersGuideAvatarImageName } from './beginnersGuideAvatarImage.t';
import { PUBLIC_URL } from '../../../../../config';

interface IBeginnersGuideAvatarImageProps {
    imageName: TBeginnersGuideAvatarImageName;
}

function BeginnersGuideAvatarImage(props: IBeginnersGuideAvatarImageProps) {
    const { imageName } = props;

    return <img src={`${PUBLIC_URL}/assets/tutorials/${imageName}.png`} className={'beginners-guide-avatar-image'}/>;
}

export default BeginnersGuideAvatarImage;
